import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import UnderConstruction from './UnderConstruction';
import FranchiseForm from './FranchiseForm';
import TermsConditions from './TermsConditions';

function MainPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [expandedState, setExpandedState] = useState(null);
  const [showMoreTestimonials, setShowMoreTestimonials] = useState(false);
  const [showUnderConstruction, setShowUnderConstruction] = useState(false);
  const [selectedStateDropdown, setSelectedStateDropdown] = useState('');
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [activeTestimonialTab, setActiveTestimonialTab] = useState('text');
  const [showFranchiseForm, setShowFranchiseForm] = useState(false);
  const [showPlayStoreModal, setShowPlayStoreModal] = useState(false);
  const [showAppStoreModal, setShowAppStoreModal] = useState(false);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [showTermsConditions, setShowTermsConditions] = useState(false);

  useEffect(() => {
    setShowWelcomeModal(true);
    
    // Track visitor count
    fetch('https://6gdhpxfyhwxxvhf36ag2ii7btu0ciipu.lambda-url.ap-south-1.on.aws/', {
      method: 'POST'
    })
    .then(response => response.json())
    .then(data => {
      console.log('Visitor count:', data.count);
    })
    .catch(error => {
      console.error('Error tracking visitor:', error);
    });
  }, []);

  if (showUnderConstruction) {
    return <UnderConstruction onBack={() => setShowUnderConstruction(false)} />;
  }
  

  
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };
  
  const moduleData = {
    auctions: {
      title: "Auctions",
      description: "Participate in live vehicle auctions and bid on premium vehicles with transparent pricing and verified documentation. Our auction platform ensures fair bidding and secure transactions."
    },
    buysell: {
      title: "Buy & Sell",
      description: "Buy or sell vehicles directly through our secure platform with instant valuation and hassle-free transactions. Connect with verified buyers and sellers nationwide."
    },
    insurance: {
      title: "Insurance & Finance",
      description: "Comprehensive insurance coverage and flexible financing options tailored to your vehicle purchase needs. Get competitive rates and quick approvals."
    },
    inspection: {
      title: "Inspection & Valuation",
      description: "Professional vehicle inspection services and accurate market valuation by certified automotive experts. Ensure quality and fair pricing for every transaction."
    },
    service: {
      title: "Service Support",
      description: "24/7 customer service support and technical assistance for all your vehicle-related queries and needs. Expert help whenever you need it."
    },
    spareparts: {
      title: "Spare Parts",
      description: "Genuine spare parts and accessories for all vehicle models with fast delivery and warranty coverage. Quality parts at competitive prices."
    }
  };
  
  const openModal = (moduleKey) => {
    setSelectedModule(moduleData[moduleKey]);
  };
  
  const closeModal = () => {
    setSelectedModule(null);
  };

  const openAboutModal = () => {
    setShowAboutModal(true);
  };

  const closeAboutModal = () => {
    setShowAboutModal(false);
  };

  const toggleState = (state) => {
    setExpandedState(expandedState === state ? null : state);
  };

  const toggleTestimonials = () => {
    setShowMoreTestimonials(!showMoreTestimonials);
  };

  const openTeamModal = () => setShowTeamModal(true);
  const closeTeamModal = () => setShowTeamModal(false);





  return (
    <div className="App">
      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
          </div>
          <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#home" className="nav-link" onClick={() => scrollToSection('home')}>Home</a></li>
            <li><a href="#marketplace" className="nav-link" onClick={() => scrollToSection('marketplace')}>Marketplace</a></li>
            <li><a href="#franchise" className="nav-link" onClick={() => scrollToSection('franchise')}>Franchise</a></li>
            <li><a href="#about" className="nav-link" onClick={() => scrollToSection('about')}>About Us</a></li>
            <li><a href="#team" className="nav-link" onClick={() => scrollToSection('team')}>Our Team</a></li>
          </ul>
        </div>
      </nav>

      {/* Home Section */}
      <section id="home" className="section home">
        <h1>India's Fastest Growing <span className="highlight">Automobile</span> Marketplace</h1>
        <p>Transforming automobile business with innovative solutions and cutting-edge technology </p>
        <a href="#marketplace" className="cta-button" onClick={() => scrollToSection('marketplace')}>Explore Now</a>
      </section>

      {/* Marketplace Section */}
      <section id="marketplace" className="section">
        <h2>Marketplace</h2>
        <div className="image-grid">
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Auctions.png" alt="Auctions" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('auctions')}>Know More</button>
          </div>
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Buy%26Sell.png" alt="Buy & Sell" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('buysell')}>Know More</button>
          </div>
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Insurance+Finance.png" alt="Insurance & Finance" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('insurance')}>Know More</button>
          </div>
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Inspection+Valuation.png" alt="Inspection & Valuation" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('inspection')}>Know More</button>
          </div>
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Service+Support.png" alt="Service Support" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('service')}>Know More</button>
          </div>
          <div className="module-item">
            <div className="image-card">
              <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Spare+Parts.png" alt="Spare Support" />
            </div>
            <button className="know-more-btn" onClick={() => openModal('spareparts')}>Know More</button>
          </div>
        </div>
        
        {selectedModule && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeModal}>&times;</button>
              <h3>{selectedModule.title}</h3>
              <p>{selectedModule.description}</p>
              <div className="app-download-section">
                <h4>Download Our App</h4>
                <div className="download-buttons">
                  <a href="https://play.google.com/store/apps/details?id=com.vahaanbazar.app" target="_blank" rel="noopener noreferrer" className="download-btn android-btn">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                  </a>
                  <a href="#" onClick={(e) => { e.preventDefault(); setShowAppStoreModal(true); }} className="download-btn ios-btn">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Mobile App Section */}
      <section id="mobile-app" className="section">
        <div className="mobile-app-container">
          <div className="mobile-app-content">
            {/* <h2>Coming Soon</h2> */}
            <h3>Experience the Future of Automobile Trading – Right in Your Pocket</h3>
            <p>With the Vahaan Bazar App, explore, trade, and grow seamlessly – anytime, anywhere </p>
            <div className="app-features">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <span>Seamless Experience</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚗</div>
                <span>All-in-One Marketplace</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📈</div>
                <span>Smart Tools for Growth</span>
              </div>
            </div>
            <div className="platform-badges">
              <div className="platform-badge" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.vahaanbazar.app', '_blank')} style={{cursor: 'pointer'}}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="store-badge" />
              </div>
              <div className="platform-badge" onClick={() => window.open('https://apps.apple.com/in/app/vahaanbazar/id6753955870', '_blank')} style={{cursor: 'pointer'}}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" className="store-badge" />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Franchise Section */}
      <section id="franchise" className="section">
        <h2>Franchise Opportunities</h2>
        <div className="franchise-container">
          <div className="franchise-intro">
            <p>Join our rapidly expanding network across Telangana and Andhra Pradesh. Exclusive franchise opportunities available in prime locations.</p>
          </div>
          
          <div className="states-grid">
            <div className="state-card">
              <h3 onClick={() => toggleState('telangana')} className="state-header">
                Telangana (TS) <span className="dropdown-arrow">{expandedState === 'telangana' ? '−' : '+'}</span>
              </h3>
              {expandedState === 'telangana' && (
                <div className="locations-grid">
                  <div className="location-item">Hyderabad <span className="outlet-count">(3 outlets)</span></div>
                  <div className="location-item">Karimnagar</div>
                  <div className="location-item">Warangal</div>
                  <div className="location-item">Khammam</div>
                  <div className="location-item">Bhadrachalam</div>
                  <div className="location-item">Nizamabad</div>
                  <div className="location-item">Adilabad</div>
                  <div className="location-item">Mahabubnagar</div>
                  <div className="location-item">Zaheerabad</div>
                  <div className="location-item">Kodad</div>
                </div>
              )}
            </div>
            
            <div className="state-card">
              <h3 onClick={() => toggleState('andhra')} className="state-header">
                Andhra Pradesh (AP) <span className="dropdown-arrow">{expandedState === 'andhra' ? '−' : '+'}</span>
              </h3>
              {expandedState === 'andhra' && (
                <div className="locations-grid">
                  <div className="location-item">Vijayawada</div>
                  <div className="location-item">Guntur</div>
                  <div className="location-item">Ellur</div>
                  <div className="location-item">Rajahmundry</div>
                  <div className="location-item">Kakinada</div>
                  <div className="location-item">Vizag</div>
                  <div className="location-item">Vijayanagaram</div>
                  <div className="location-item">Srikakulam</div>
                  <div className="location-item">Kadapa</div>
                  <div className="location-item">Kurnool</div>
                  <div className="location-item">Chittoor</div>
                  <div className="location-item">Anantapur</div>
                  <div className="location-item">Nellore</div>
                  <div className="location-item">Ongole</div>
                </div>
              )}
            </div>
          </div>
          
          <div className="franchise-cta">
            <button className="interested-btn" onClick={() => setShowFranchiseForm(true)}>Interested? Apply Now</button>
            <button className="download-brochure-btn" onClick={() => window.open('#', '_blank')}>Download Brochure</button>
          </div>
        </div>
      </section>

      {/* Franchise Locations Section */}
      <section id="franchise-locations" className="section">
        <h2>Our Franchise Network</h2>
        <div className="franchise-locations-container">
          <div className="locations-intro">
            <p>Expanding across India with strategic franchise locations to serve you better</p>
          </div>
          
          <div className="locations-content">
            <div className="current-location">
              <div className="location-header">
                <h3>🎉 Now Open - AutoNagar Branch</h3>
              </div>
              <div className="location-details">
                <div className="address-section">
                  <h4>📍 Address</h4>
                  <p>Plot no 20A, Block no 43, Shutter 3,<br />beside Panduranga Agencies,<br />Autonagar, Hyderabad - 500070</p>
                </div>
                <div className="map-section">
                  <button 
                    className="map-btn" 
                    onClick={() => window.open('https://www.google.com/maps?q=17.34092,78.5793763&z=17&hl=en', '_blank')}
                  >
                    🗺️ View on Google Maps
                  </button>
                </div>
              </div>
            </div>
            
            <div className="upcoming-message">
              <h3>🚀 More Franchise Locations Coming Soon</h3>
              <p>We are rapidly expanding across Telangana and Andhra Pradesh. Stay tuned for new locations!</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="section">
        <h2>About Us</h2>
        <div className="about-container">
          <div className="about-content">
            <h3>Revolutionizing the Automotive Industry</h3>
            <p>VahaanBazar is India's leading digital automotive marketplace, transforming how people buy, sell, and service vehicles. We combine cutting-edge technology with deep industry expertise to create seamless experiences for customers across the automotive ecosystem.</p>
            <div className="stats-grid">
              <div className="stat-item">
                <h4>5,000+</h4>
                <span>Registered Users</span>
              </div>
              <div className="stat-item">
                <h4>2000+</h4>
                <span>Listed Vehicles</span>
              </div>
              <div className="stat-item">
                <h4>26+</h4>
                <span>Franchises About to Open</span>
              </div>
            </div>
            <button className="about-cta" onClick={openAboutModal}>Know More About Us</button>
          </div>
        </div>
      </section>

      {showAboutModal && (
        <div className="modal-overlay" onClick={closeAboutModal}>
          <div className="modal-content team-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeAboutModal}>&times;</button>
            <h3>About VahaanBazar</h3>
            <div className="founder-details">
              <div className="founder-section">
                <p>VahaanBazar is India's premier digital automotive marketplace, founded with the vision to revolutionize how people buy, sell, and service vehicles. Our platform combines cutting-edge technology with deep industry expertise to create seamless experiences for customers across the automotive ecosystem.</p>
              </div>
              <div className="founder-section">
                <p>Since our inception, we have been committed to transparency, innovation, and customer satisfaction. We provide comprehensive solutions including vehicle auctions, buy & sell services, insurance & finance options, inspection & valuation services, service support, and genuine spare parts.</p>
              </div>
              <div className="founder-section">
                <p>Our mission is to make automotive transactions simple, secure, and accessible to everyone while maintaining the highest standards of quality and service.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Our Team Section */}
      <section id="team" className="section">
        <h2>Our Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <h3>Shameer Shaik</h3>
            <div className="role">Co-Founder & CEO </div>
            <p>Driven by a rich family legacy in automobiles, Shameer is digitizing and scaling the automobile vehicle market through technology and a focus on trust.</p>
          </div>
          <div className="team-member">
            <h3>Pranay Kumar </h3>
            <div className="role">Co-Founder & COO</div>
            <p>Leveraging deep expertise from sales to SaaS to build a trusted and innovative ecosystem for automobile industry in India.</p>
          </div>
          <div className="team-member">
            <h3>Pavan Kumar</h3>
            <div className="role">CTO</div>
            <p>An AI and automation expert building an intelligent, tech-driven platform for the automotive industry.</p>
          </div>
        </div>
        <div className="team-cta">
          <button className="team-know-more-btn" onClick={openTeamModal}>Know More About Our Founders</button>
        </div>
      </section>

      {showTeamModal && (
        <div className="modal-overlay" onClick={closeTeamModal}>
          <div className="modal-content team-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeTeamModal}>&times;</button>
            <h3>Meet Our Founders</h3>
            <div className="founder-details">
              <div className="founder-section">
                <h4>Shameer Shaik - Co-Founder & CEO</h4>
                <p>With over a decade of executive experience in the automobile industry and a five-decade family legacy in the trade, Shameer brings a unique depth of knowledge to his role. He has held key leadership positions at major organizations like Ashok Leyland, Auctomate, iQuippo, and LocoNav, where he was instrumental in driving growth, operational excellence, and digital transformation.</p>
                <br></br>
                <p>As the Co-Founder and CEO of Vahaan Bazar, Shameer is spearheading the vision to digitize, organize, and scale India's used vehicle ecosystem. By leveraging cutting-edge technology, deep industry expertise, and an unwavering commitment to trust, he is revolutionizing how vehicles are bought, sold, and managed across the country. Under his guidance, Vahaan Bazar is emerging as a next-generation, technology-driven marketplace that seamlessly connects buyers, sellers, and franchise partners.</p>
              </div>
              <div className="founder-section">
                <h4>Pranay Kumar - Co-Founder & COO</h4>
                <p>With over 12 years of experience spanning both Indian and global automobile markets, he has a proven track record in senior positions at industry leaders like Ashok Leyland, TVS Motors, and LocoNav. His expertise encompasses sales, supply chain management, SaaS solutions, and operational excellence.</p>
                <br></br>
                <p>As Co-Founder and COO of Vahaan Bazar, he applies this deep industry knowledge to drive the company's strategic expansion across digital and field operations. His leadership has been pivotal in solidifying Vahaan Bazar's position as a trusted and innovative marketplace, delivering seamless, integrated solutions for buyers, sellers, and franchise partners.</p>
              </div>
              <div className="founder-section">
                <h4>Pavan Kumar - CTO</h4>
                <p>Pavan brings deep expertise in artificial intelligence (AI), data analytics, and automation to his role. With a strong focus on innovation and scalability, he architects and implements cutting-edge solutions that enhance efficiency, accuracy, and user experience throughout the automotive resale ecosystem.</p>
                <br></br>
                <p>As Chief Technology Officer (CTO) of Vahaan Bazar, Pavan is responsible for ensuring the company's technological leadership. He drives the development of a seamless, integrated platform that connects buyers, sellers, and franchise partners, directly advancing the company's vision of a digital-first, intelligent automobile marketplace.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Testimonials Section */}
      <section id="testimonials" className="section">
        <h2>What Our Customers Say</h2>
        <div className="testimonials-container">
          <div className="testimonial-tabs">
            <button 
              className={`tab-btn ${activeTestimonialTab === 'text' ? 'active' : ''}`}
              onClick={() => setActiveTestimonialTab('text')}
            >
              📝 Written Reviews
            </button>
            <button 
              className={`tab-btn ${activeTestimonialTab === 'video' ? 'active' : ''}`}
              onClick={() => setActiveTestimonialTab('video')}
            >
              🎥 Video Reviews
            </button>
          </div>
          
          {activeTestimonialTab === 'text' && (
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="rating">
                  <span className="stars">★★★★★</span>
                  <span className="rating-text">5.0</span>
                </div>
                <p>"VahaanBazar made selling my car incredibly easy. The platform is user-friendly and I got the best price for my vehicle. Highly recommend their services!"We are happy to announce Vahaan Bazar as our liquidation partner. Our experience over the past two months led us to make this decision quickly. We successfully sold 4 machines and 8 tippers through Vahaan Bazar. We highly recommend them for all used commercial vehicle buying and selling."</p>
                <div className="customer-name">Srikumar Enterprises, Hyderabad</div>
              </div>
              <div className="testimonial-card">
                <div className="rating">
                  <span className="stars">★★★★★</span>
                  <span className="rating-text">5.0</span>
                </div>
                <p>"We are very happy with the service provided by Vahaan Bazar for the sale of our Kobeico 210 machine. We confidently recommend Vahaan Bazar for all kinds of used asset resale."</p>
                <div className="customer-name">Bismillah Enterprises, Vijayawada</div>
              </div>
            </div>
          )}
          
          {activeTestimonialTab === 'video' && (
            <div className="video-testimonials-grid">
              <div className="video-testimonial-card">
                <div className="video-container">
                  <video 
                    controls
                    preload="metadata"
                  >
                    <source src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Review+1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <div className="rating">
                    <span className="stars">★★★★★</span>
                    <span className="rating-text">5.0</span>
                  </div>
                </div>
              </div>
              <div className="video-testimonial-card">
                <div className="video-container">
                  <video 
                    controls
                    preload="metadata"
                  >
                    <source src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Review+2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <div className="rating">
                    <span className="stars">★★★★★</span>
                    <span className="rating-text">5.0</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Ads Section */}
      <section id="ads" className="section">
        <h2>Featured Advertisements</h2>
        <div className="ads-container">
          <div className="ads-scroll">
            <div className="ads-track">
              <div className="ad-card" onClick={() => window.open('https://example.com/auctions', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Auctions.png" alt="Auctions Ad" />
                <div className="ad-overlay">
                  <h3>Live Auctions</h3>
                  <p>Bid on premium vehicles online</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/buysell', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Buy%26Sell.png" alt="Buy & Sell Ad" />
                <div className="ad-overlay">
                  <h3>Buy & Sell Vehicles</h3>
                  <p>Best platform for vehicle transactions</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/insurance', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Insurance+Finance.png" alt="Insurance & Finance Ad" />
                <div className="ad-overlay">
                  <h3>Insurance & Finance</h3>
                  <p>Complete financial solutions for vehicles</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/inspection', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Inspection+Valuation.png" alt="Inspection & Valuation Ad" />
                <div className="ad-overlay">
                  <h3>Inspection & Valuation</h3>
                  <p>Professional vehicle assessment services</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/service', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Service+Support.png" alt="Service Support Ad" />
                <div className="ad-overlay">
                  <h3>Service Support</h3>
                  <p>Expert maintenance and repair services</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/spareparts', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Spare+Parts.png" alt="Spare Parts Ad" />
                <div className="ad-overlay">
                  <h3>Genuine Spare Parts</h3>
                  <p>Original parts with warranty guarantee</p>
                </div>
              </div>
            </div>
            <div className="ads-track">
              <div className="ad-card" onClick={() => window.open('https://example.com/auctions', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Auctions.png" alt="Auctions Ad" />
                <div className="ad-overlay">
                  <h3>Live Auctions</h3>
                  <p>Bid on premium vehicles online</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/buysell', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Buy%26Sell.png" alt="Buy & Sell Ad" />
                <div className="ad-overlay">
                  <h3>Buy & Sell Vehicles</h3>
                  <p>Best platform for vehicle transactions</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/insurance', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Insurance+Finance.png" alt="Insurance & Finance Ad" />
                <div className="ad-overlay">
                  <h3>Insurance & Finance</h3>
                  <p>Complete financial solutions for vehicles</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/inspection', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Inspection+Valuation.png" alt="Inspection & Valuation Ad" />
                <div className="ad-overlay">
                  <h3>Inspection & Valuation</h3>
                  <p>Professional vehicle assessment services</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/service', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Service+Support.png" alt="Service Support Ad" />
                <div className="ad-overlay">
                  <h3>Service Support</h3>
                  <p>Expert maintenance and repair services</p>
                </div>
              </div>
              <div className="ad-card" onClick={() => window.open('https://example.com/spareparts', '_blank')}>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Spare+Parts.png" alt="Spare Parts Ad" />
                <div className="ad-overlay">
                  <h3>Genuine Spare Parts</h3>
                  <p>Original parts with warranty guarantee</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {showWelcomeModal && (
        <div className="modal-overlay" onClick={() => setShowWelcomeModal(false)}>
          <div className="modal-content welcome-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowWelcomeModal(false)}>&times;</button>
            <div className="welcome-logo">
              <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
            </div>
            <h3>🎉We Have Launched VahaanBazar Mobile App!</h3>
            <div className="welcome-content">
              <p>Experience the future of automobile trading right in your pocket.</p>
              <p className="registration-notice">For account activation, registration and login download mobile app.</p>
              <div className="download-section">
                <h4>Download Now</h4>
                <div className="download-badges">
                  <div className="playstore-badge" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.vahaanbazar.app', '_blank')}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                  </div>
                  <div className="appstore-badge" onClick={() => window.open('https://apps.apple.com/in/app/vahaanbazar/id6753955870', '_blank')}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPlayStoreModal && (
        <div className="modal-overlay" onClick={() => setShowPlayStoreModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowPlayStoreModal(false)}>&times;</button>
            <h3>Download VahaanBazar App</h3>
            <div className="qr-download-section">
              <div className="qr-section">
                <h4>Scan QR to Download</h4>
                <img src="https://wip-vahaan.s3.ap-south-1.amazonaws.com/Vahaan-Andriod-QR-SVG.svg" alt="QR Code" className="qr-code" />
              </div>
              <div className="download-section">
                <h4>Or Download Directly</h4>
                <button className="download-direct-btn" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.vahaanbazar.app', '_blank')}>
                  PlayStore
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAppStoreModal && (
        <div className="modal-overlay" onClick={() => setShowAppStoreModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowAppStoreModal(false)}>&times;</button>
            <h3>Coming Soon to App Store!</h3>
            <div className="coming-soon-content">
              <p>We're working hard to bring VahaanBazar to the App Store. You'll receive a notification once we're available for download.</p>
              <p>Stay tuned for updates!</p>
            </div>
          </div>
        </div>
      )}

      {showNotifyModal && (
        <div className="modal-overlay" onClick={() => setShowNotifyModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowNotifyModal(false)}>&times;</button>
            <h3>VahaanBazar App Status</h3>
            <div className="notify-content">
              <div className="available-section">
                <h4>📱Available Now on Play Store!</h4>
                <p>Download VahaanBazar app from Google Play Store and start your automobile trading journey.</p>
                <button className="download-now-btn" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.vahaanbazar.app', '_blank')}>
                  Download from Play Store
                </button>
              </div>
              <div className="coming-soon-section">
                <h4>📱Coming Soon to App Store</h4>
                <p>We're working hard to bring VahaanBazar to the App Store. You'll receive a notification once we're available for download.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showFranchiseForm && (
        <FranchiseForm onClose={() => setShowFranchiseForm(false)} />
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
              </div>
              <p>India's leading digital automotive marketplace, transforming vehicle transactions with cutting-edge technology.</p>
              <div className="social-links">
                <a href="https://www.facebook.com/share/17F53TCGBp/" aria-label="Facebook">f</a>
                <a href="#" aria-label="Twitter">𝕏</a>
                <a href="https://www.instagram.com/vahaanbazar?igsh=MTFxOWluMjEwMDJyMw==" aria-label="Instagram">📷</a>
                <a href="https://www.linkedin.com/company/vahaan-bazar-private-limited/" aria-label="LinkedIn">in</a>
              </div>
            </div>
            
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><a href="#">Vehicle Auctions</a></li>
                <li><a href="#">Buy & Sell</a></li>
                <li><a href="#">Insurance & Finance</a></li>
                <li><a href="#">Inspection & Valuation</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#team">Our Team</a></li>
                <li><a href="#franchise">Franchise</a></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions">Terms of Service</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Contact Info</h4>
              <div className="contact-info">
                <p>📍 VahaanBazar Private Limited, No 302, Plot No 135, Godha Nilayam, Phase 6, KPHB Colony, Hyderabad - 500072</p>
                <p>📞 +91 9840469298</p>
                <p>✉️ contactus@vahaanbazar.com</p>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2026 Vahaan Bazar Private Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return <MainPage />;
}

export default App;